import React, { FC } from "react"
import L10n from "../../../lib/carrot-l10n"
import { Spacer } from "../atoms/Atoms"
import { useFormContext } from "react-hook-form"
import FieldNames from "../../../utils/FieldNames"
import { Modal } from "../modal/Modal"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { H2 } from "@carrotfertility/carotene"
import { Body } from "../atoms/Bodies"
import { FormListSingleSelect } from "../atoms/forms/FormListSingleSelect"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type SelectWithTitleProps = {
  reimbursementJourneys: any
}
const name = FieldNames.REIMBURSEMENT_TYPE.valueOf()

const SelectWithTitle: FC<SelectWithTitleProps> = ({ reimbursementJourneys }) => {
  const { register } = useFormContext()
  return (
    <>
      <Spacer height={1.5} />
      <div className="pl45-ns pl35-s pr5">
        <H2>{l`What is this expense related to?`}</H2>
        <Spacer height={1.5} />
        <Body color="black-60">{l`If you're not sure, don't worry. Just choose the option that seems like the best fit.`}</Body>
      </div>
      <Spacer height={1.5} />
      <FormListSingleSelect options={reimbursementJourneys} name={name} ref={register({ required: true })} />
    </>
  )
}
type ReimbursementsModalProps = {
  reimbursementJourneys: any
  onClose: () => void
  onSubmit: () => Promise<void>
}

const ReimbursementsModal: FC<ReimbursementsModalProps> = ({ reimbursementJourneys, onClose, onSubmit }) => {
  const {
    formState: { isValid }
  } = useFormContext()

  return (
    <form onSubmit={onSubmit}>
      <Modal titleText={l`What is this expense related to?`} onExit={onClose}>
        <div className="w-100">
          <SelectWithTitle reimbursementJourneys={reimbursementJourneys} />
          <div className="tr pr35-s pr45-ns pv35-s pv45-ns">
            <ButtonPrimary id="form-list-single-select-button" enabled={isValid} onClick={onSubmit} type="submit">
              {l`Next`}
            </ButtonPrimary>
          </div>
        </div>
      </Modal>
    </form>
  )
}

export default ReimbursementsModal
